<template>
  <v-app id="app">
    <transition name="page-slide" mode="out-in">
      <router-view/>
    </transition>
    <v-snackbar
      v-for="(toast, index) in toasts"
      :key="toast.id"
      :value="true"
      :style="`padding-top: ${60 * index}px`"
      top
      right
      :color="toast.color"
      :timeout="
      toast.persist ? -1 :
      toast.type === 'loading' ? -1 :
      toast.type === 'loadingSuccess' ? -1 :
      toast.type === 'loadingError' ? -1 :
      toast.duration ? toast.duration :
      5000"
    >
      <div style="display: flex; justify-content: space-between;align-items: center; width: 100%">
        <div
          v-if="toast.type === 'success' || toast.type === 'loadingSuccess'"
          style="height: 40px; width: 40px;"
        >
          <CheckmarkWhite />
        </div>

        <div
          v-if="toast.type === 'error' || toast.type === 'loadingError'"
          style="height: 40px; width: 40px;"
        >
          <CancelWhite />
        </div>

        <span>{{
        toast.message
        }}</span>

        <VIcon
          v-if="toast.persist"
          style="cursor: pointer;"
          @click="removeToast(toast.id)"
          medium
        >mdi-close</VIcon>
        <VProgressCircular
          v-else-if="toast.type === 'loading'"
          size="25"
          indeterminate
          color="white"
        />
        <VIcon
          v-else-if="toast.type === 'loadingSuccess'"
          medium
        >
          mdi-check
        </VIcon>
        <VIcon
          v-else-if="toast.type === 'loadingError'"
          medium
        >
          mdi-close
        </VIcon>
      </div>
    </v-snackbar>
  </v-app>
</template>

<script>
import * as Sentry from '@sentry/browser';
import { Vue as VueIntegration } from '@sentry/integrations/dist/vue';
import Vue from 'vue';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import CheckmarkWhite from '@/modules/svg/CheckmarkWhite.vue';
import CancelWhite from '@/modules/svg/CancelWhite.vue';
import { store } from './store';

export default {
  components: {
    VProgressCircular,
    CheckmarkWhite,
    CancelWhite,
  },
  data() {
    return {
      toasts: [],
    };
  },
  methods: {
    addToast(message, config = {
      persist: false,
      type: 'info',
      duration: 5000,
      id: Math.floor(Math.random() * 1000000),
    }) {
      this.toasts.push({
        id: config.id,
        message,
        persist: !!config.persist,
        duration: config.duration,
        type: config.type,
        // eslint-disable-next-line no-nested-ternary
        color: config.type === 'error' ? 'red' : config.type === 'loadingError' ? 'red' : config.type === 'success' ? 'green' : config.type === 'loading' ? 'green' : config.type === 'loadingSuccess' ? 'green' : '#363636',
      });

      if (!config.persist && config.type !== 'loading') {
        console.log('auto cancel');
        setTimeout(() => {
          this.removeToast(config.id);
        }, config.duration ? config.duration + 500 : 5500);
      }
    },
    updateToast(id, payload) {
      const updateIndex = this.toasts.findIndex((toast) => toast.id === id);
      if (updateIndex !== -1) {
        this.toasts.splice(updateIndex, 1, { ...this.toasts[updateIndex], ...payload });
      }

      if (payload.type === 'loadingSuccess' || payload.type === 'loadingError') {
        setTimeout(() => {
          this.removeToast(id);
        }, 1000);
      }
    },
    removeToast(id) {
      const removeIndex = this.toasts.findIndex((toast) => toast.id === id);
      if (removeIndex !== -1) {
        this.toasts.splice(removeIndex, 1);
      }
    },
  },
  created() {
    Vue.prototype.$toast = this.addToast;
    Vue.prototype.$removeToast = this.removeToast;
    Vue.prototype.$updateToast = this.updateToast;
    store.subscribe((mutation) => {
      if (mutation.type === 'setToast') {
        this.addToast(mutation.payload.message, { ...mutation.payload.config });
      }
    });

    // initiate sentry
    if (process.env.VUE_APP_SENTRY_ENVIRONMENT === 'production') {
      Sentry.init({
        dsn: process.env.VUE_APP_SENTRY_DSN,
        integrations: [new VueIntegration({
          Vue,
          attachProps: true,
        })],
        environment: process.env.VUE_APP_SENTRY_ENVIRONMENT,
      });
    }
  },
};
</script>

<style lang="scss">
  // Global CSS

  // This is to fix vuetify's bugged scrollbar on html appearing even when not needed
  html {
    overflow: auto !important;
    font-family: Avenir, Helvetica, Arial, sans-serif;
  }

  body {
    margin: 0px;
  }

  #app {
    font-family: Roboto, Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    background-color: #f2f4ff;
  }

  .page {
    flex: 1;
    display: flex;
    flex-direction: column;
  }

  .w-100 {
    width: 100%;
  }

  // Vuetify CSS Overwrites
  .v-btn {
    text-transform: none !important;
  }

  .page-title {
    font-size: 30px;
    color: #393939;
    font-weight: 400;
  }

  .page-sub-title {
    font-size: 24px;
    color: #393939;
    font-weight: 400;
  }

  .position-relative {
    position: relative;
  }

  // v-slider thumb size override
  .v-slider__thumb {
    width: 24px !important;
    height: 24px !important;
    margin-left: -6px;
    cursor: pointer;

    &::before {
      height: 46px !important;
      width: 46px !important;
    }
  }

  .v-stepper-hide-icon .v-stepper__step__step {
    display: none !important;
  }

  .dialog-center-margin {
    margin-left: 300px !important;
  }

  // vue transitions

  // slide
  .slide-enter {
    margin-left: -30px;
    opacity: 0;
  }

  .slide-enter-to {
    margin-left: 0px;
    opacity: 1;
  }

  .slide-enter-active {
    transition: all .3s ease;
  }

  .slide-leave {
    margin-left: 0px;
    opacity: 1;
  }

  .slide-leave-to {
    margin-left: -30px;
    opacity: 0;
  }

  .slide-leave-active {
    transition: all .3s ease;
  }

  // fade
  .fade-enter {
    opacity: 0;
  }

  .fade-enter-to {
    opacity: 1;
  }

  .fade-enter-active {
    transition: opacity 0.3s;
  }

  .fade-leave {
    opacity: 1;
  }

  .fade-leave-to {
    opacity: 0;
  }

  .fade-leave-active {
    transition: all .3s ease;
  }

  // page-slide

  .page-slide-enter-active {
    transition: all 0.3s;
  }

  .page-slide-leave-active {
    transition: all .3s;
  }

  // page-slide page part
  .page-slide-enter .page {
    margin-left: -30px;
    opacity: 0;
  }

  .page-slide-enter-to .page {
    margin-left: 0px;
    opacity: 1;
  }

  .page-slide-enter-active .page {
    transition: all .3s ease;
  }

  .page-slide-leave .page {
    margin-left: 0px;
    opacity: 1;
  }

  .page-slide-leave-to .page {
    margin-left: -30px;
    opacity: 0;
  }

  .page-slide-leave-active .page {
    transition: all .3s ease;
  }

  // page-slide sidebar part

  .page-slide-enter .sidebar-content {
    opacity: 0 !important;
  }

  .page-slide-enter-to .sidebar-content {
    opacity: 1 !important;
  }

  .page-slide-enter-active .sidebar-content {
    transition: all .3s !important;
  }

  .page-slide-leave .sidebar-content {
    opacity: 1 !important;
  }

  .page-slide-leave-to .sidebar-content {
    opacity: 0 !important;
  }

  .page-slide-leave-active .sidebar-content {
    transition: all .3s !important;
  }

</style>
